import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=41b96a57&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b96a57",
  null
  
)

export default component.exports